var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7773 9.15234L10.875 13.0582L9.19102 11.4023C8.86143 11.0728 8.32758 11.0728 7.99781 11.4023C7.66805 11.7319 7.66822 12.2658 7.99781 12.5955L10.2478 14.8455C10.4426 15.0129 10.657 15.0938 10.875 15.0938C11.093 15.0938 11.3067 15.0113 11.4716 14.8466L15.9716 10.3466C16.3012 10.017 16.3012 9.48313 15.9716 9.15336C15.642 8.8236 15.1078 8.82539 14.7773 9.15234ZM12 3C7.02891 3 3 7.02891 3 12C3 16.9711 7.02891 21 12 21C16.9711 21 21 16.9711 21 12C21 7.02891 16.9711 3 12 3ZM12 19.3125C7.96758 19.3125 4.6875 16.0321 4.6875 12C4.6875 7.96793 7.96758 4.6875 12 4.6875C16.0324 4.6875 19.3125 7.96793 19.3125 12C19.3125 16.0321 16.0324 19.3125 12 19.3125Z",
    fill: "#002C38"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.92747d3d0f8708ac91a7a784547144e1.svg";
export { ForwardRef as ReactComponent };